import React, { useEffect, useRef, useState } from 'react'
import { useBoolean } from "@fluentui/react-hooks";
import { IColumn, ICommandBarItemProps, ISearchBox } from '@fluentui/react';
import IconHelper from '../../../utils/helpers/iconHelper';
import { CabeceraTable } from '../../../components/Table/CabeceraTable';
import { TableBase2 } from '../../../components/Table/TableBase2';
import { PaginationFooterC } from '../../../components/PaginationFooter/PaginationFooterC';
import dispositivoServicio from '../../../services/dispositivo/dispositivoService';
import { IPaginacion } from '../../../Interfaces/filter';
import { IDispositivo } from '../../../Interfaces/IDispositivos';
import { IfilterDispositivos, filtroInicialDisp } from '../../../Interfaces/dispositivo/IDispositivo';


export const TablaDispositivos = () => {

    const controllerRefAbort = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<IfilterDispositivos>(
        filtroInicialDisp
    );
    const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
    const [itemsTable, setItemsTable] = useState<IDispositivo[]>([]);
    const [loadingTable, setLoadingTable] = useState(false);


    const searchBoxRefTable = useRef<ISearchBox>(null);
    const _onkeyUpSearchDispositivo = (
        event: React.KeyboardEvent<HTMLInputElement>
    ) => {
        let { value } = event?.target as HTMLInputElement;
        setFilter({ ...filter, search: value });
    };

    const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
        useBoolean(false);

    const column: IColumn[] = [
        {
            key: "codigo",
            name: "Código",
            fieldName: "codigo",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            key: "serie",
            name: "Serie",
            fieldName: "serie",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            key: "imei",
            name: "IMEI",
            fieldName: "imei",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            key: "marca",
            name: "Marca",
            fieldName: "marca",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            key: "modelo",
            name: "Modelo",
            fieldName: "modelo",
            minWidth: 150,
            maxWidth: 400,
            isResizable: true,
        },
        {
            key: "fechaRegistro",
            name: "Fecha de Registro",
            fieldName: "fechaRegistro",
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
        },
        // {
        //     key: "serie",
        //     name: "Serie",
        //     fieldName: "serie",
        //     minWidth: 150,
        //     maxWidth: 150,
        //     isResizable: false,
        //     onRender: (item: any) => (
        //         <span style={{ fontWeight: "bold", fontSize: 12 }}>{item.nroDOI}</span>
        //     ),
        // },
    ];

    // const rigth_items: ICommandBarItemProps[] = [
    //     {
    //         ...IconHelper.ICON_FILTER,
    //         onClick: () => {
    //             openPanel();
    //         },
    //     },
    //     {
    //         ...IconHelper.ICON_EXCEL,
    //         text: "Descargar Reporte",
    //         onClick: () => {
    //             openPaneReportel();
    //         },
    //     },
    // ];
    const left_items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            onClick: () => {
                actualizarTabla();
            },
        },
    ];

    const actualizarTabla = () => {
        postTablaDispositivos();
    };

    const postTablaDispositivos = () => {
        setLoadingTable(true);
        controllerRefAbort.current.abort();
        const newController = new AbortController();
        controllerRefAbort.current = newController;
        dispositivoServicio
            .listarTablets(filter, newController)
            .then((res) => {
                if (res.status === 200) {
                    setItemsTable(res.data.data);
                    console.log(res.data)
                    console.log(res.data.total)
                    console.log(res.data.page)
                    console.log(res.data.pages)
                    setPaginacion({
                        page: res.data.page,
                        total: res.data.total,
                        pages: res.data.pages,
                    });

                }
                setLoadingTable(false);
            })
            .catch((err) => {
                setLoadingTable(false);
                console.log(err);
            });
    };

    const onChangeSkip = (evento: string) => {
        switch (evento) {
            case "next":
                setFilter({ ...filter, skip: filter.skip + 1 });
                break;
            case "prev":
                setFilter({ ...filter, skip: filter.skip - 1 });
                break;

            default:
                break;
        }
    };



    useEffect(() => {
        postTablaDispositivos();
    }, [filter]);

    return (
        <div>
            <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <CabeceraTable
                        placeholder="Buscar Por Código"
                        componentRef={searchBoxRefTable}
                        Titulo="Dispositivo"
                        SubTitulo="Lista de dispositivos"
                        onKeyUp={_onkeyUpSearchDispositivo}
                    />
                </div>
            </div>
            <br />
            <TableBase2
                leftBar={left_items}
                // rigthBar={rigth_items}
                data={itemsTable}
                column={column}
                isLoading={loadingTable}
                // isLoading={false}
                // footerPagination={
                //     <PaginationFooterC
                //         paginacion={paginacion}
                //         onChangePagina={(e) => {
                //             onChangeSkip(e);
                //         }}
                //     />
                // }
                footerPagination={
                    <PaginationFooterC
                        paginacion={paginacion}
                        onChangePagina={(e) => {
                            onChangeSkip(e);
                        }}
                    />
                }
            />
        </div>
    );
};